import React from "react";
import { Box, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import Skeleton from "@material-ui/lab/Skeleton";
import { formatPercent } from "../../pages/Dashboard/format";

const LABELS = {
  1: "Muito insatisfeito",
  2: "Insatisfeito",
  3: "Regular",
  4: "Satisfeito",
  5: "Muito satisfeito",
};

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2), height: "100%" },
  title: { fontWeight: 600 },
  big: { fontSize: "1.8rem", fontWeight: 700, lineHeight: 1 },
  muted: { color: theme.palette.text.secondary },
  row: {
    display: "grid",
    gridTemplateColumns: "140px minmax(0, 1fr) 36px",
    alignItems: "center",
    columnGap: theme.spacing(1),
    fontSize: "0.8rem",
    padding: theme.spacing(0.4, 0),
  },
  track: {
    height: 6,
    borderRadius: 4,
    backgroundColor: theme.palette.action.hover,
    overflow: "hidden",
  },
  bar: { height: "100%", borderRadius: 4, backgroundColor: theme.palette.primary.main },
  value: { textAlign: "right", fontWeight: 700 },
}));

export default function RatingSummary({ counters = {}, distribution = [], loading }) {
  const classes = useStyles();
  const total = distribution.reduce((s, d) => s + d.total, 0);
  const avg = counters.ratingAvg;

  return (
    <Paper className={classes.root}>
      <Typography variant="subtitle1" className={classes.title}>
        Avaliações
      </Typography>
      {loading ? (
        <Skeleton variant="rect" height={120} style={{ borderRadius: 8 }} />
      ) : !total ? (
        <Typography variant="body2" className={classes.muted} style={{ padding: 16, textAlign: "center" }}>
          Nenhuma avaliação no período
        </Typography>
      ) : (
        <>
          <Box display="flex" alignItems="center" style={{ gap: 12 }} mt={1} mb={1.5}>
            <span className={classes.big}>
              {avg !== null && avg !== undefined
                ? avg.toLocaleString("pt-BR", { maximumFractionDigits: 1 })
                : "—"}
            </span>
            <div>
              <Rating value={avg || 0} precision={0.1} max={5} readOnly size="small" />
              <Typography variant="caption" component="div" className={classes.muted}>
                {total} avaliaç{total === 1 ? "ão" : "ões"}
                {counters.ratingResponseRate !== null && counters.ratingResponseRate !== undefined
                  ? ` · ${formatPercent(counters.ratingResponseRate)} responderam`
                  : ""}
              </Typography>
            </div>
          </Box>
          {[5, 4, 3, 2, 1].map((rate) => {
            const item = distribution.find((d) => d.rate === rate);
            const count = item ? item.total : 0;
            return (
              <div key={rate} className={classes.row} title={`${LABELS[rate]}: ${count}`}>
                <span>
                  {rate} · {LABELS[rate]}
                </span>
                <div className={classes.track}>
                  <div className={classes.bar} style={{ width: `${(count / total) * 100}%` }} />
                </div>
                <span className={classes.value}>{count}</span>
              </div>
            );
          })}
        </>
      )}
    </Paper>
  );
}
